<template>
    <span class="prop-advance">
        <span class="enter-icon icon iconfont icon-function" @click="showDetail"></span>
        <Modal
            v-model="isShow"
            title="数据详情"
            @on-ok="ok">
            <Tabs>
                <TabPane label="数据">
                    <div>
                        {{data}}
                    </div>
                </TabPane>
                <TabPane label="格式化">
                    <TransformerEditor :transformers="transformers" :allFunctionsMap="allFunctionsMap" :orginData="data"></TransformerEditor>
                </TabPane>
            </Tabs>
        </Modal>
    </span>
</template>
<style lang="less">
    .prop-advance{
        .enter-icon{
            color:#2181EA; 
            font-size:8px; 
            padding-right:3px;
            border: solid 1px #0F1317;
            cursor: pointer;
        }
        .enter-icon:hover{
            border: solid 1px #2181EA;
        }
    }
</style>
<script>
import TransformerEditor from '../function-editor/index';
import * as dataBuilder from '@/runtime-components/data-builder/index';
export default {
    props:['value', 'config', 'prop','allFunctionsMap'],
    components:{TransformerEditor},
    data() {
        return {
            isShow:false,
            errorInfo:'',
            data:null,
            transformers:null
        }
    },
    mounted() {
    },
    watch: {
        value:{
            handler(){
                this.transformers = this.value?JSON.parse(JSON.stringify(this.value)):[];
            },
            immediate:true
        },
        config:{
            handler(){
                if(!this.prop.async){
                    this.data = this.config;
                }else{
                    dataBuilder.fetch(this.prop.type.name, this.config).then(data=>{
                        this.data = data;
                    });
                }
            },
            immediate:true
        }
    },
    methods: {
        showDetail(){
            this.isShow = true;
        },

        ok(){
            this.$emit('input',  this.transformers)
            this.$emit('save');
        }
    },

}
</script>